import { PendenciesTabEnum } from '@/pages/pendencies/PendenciesPage';
import { ROUTES } from '@/utils/routes';

export function buildPendenciesTabLink(
  tab: PendenciesTabEnum,
  klassId?: number,
) {
  const searchParams = new URLSearchParams({ tab });
  if (klassId) searchParams.set('klassId', String(klassId));
  return `${ROUTES.PENDENCIES.BASE}?${searchParams.toString()}`;
}
